import { FieldValidator } from 'formik';

export const notEmpty: FieldValidator = (value: any) => {
  return /^\s*$/i.test(value) || value == null ? 'error.required' : undefined;
};
